import { sdk } from '@/services/sdk';
import { PRODUCT_FIELDS } from '@/shared/fields';
import { rows } from '@/shared/data';

const FRESH_FOR_MS = 15000;

let cache = null;

/**
 * Every product row, ordered for display. The home page has three sections that read the
 * catalog (plans, Desktop Telly, extra products); they share this one request.
 */
export function loadProducts() {
  const now = Date.now();
  if (cache && now - cache.at < FRESH_FOR_MS) return cache.request;

  const request = sdk
    .table('products_c')
    .select(PRODUCT_FIELDS)
    .orderBy('sort_c')
    .limit(100)
    .fetch()
    .then(rows);

  cache = { at: now, request };
  request.catch(() => {
    if (cache?.request === request) cache = null;
  });
  return request;
}
